import Callback from '../../../core/module/callback'
import Line from './line'
import Small from './small'
import SmallNext from './small_next'
import Mark from './mark'
import Card from './card'

export default {
    Line,
    Card,
    Small,
    SmallNext,
    Mark,
    Callback
}